import { render, staticRenderFns } from "./guidelinePage.vue?vue&type=template&id=6c19473a&scoped=true&"
import script from "./guidelinePage.vue?vue&type=script&lang=ts&"
export * from "./guidelinePage.vue?vue&type=script&lang=ts&"
import style0 from "./guidelinePage.vue?vue&type=style&index=0&id=6c19473a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19473a",
  null
  
)

export default component.exports